
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M105.802 60c1.214 0 2.203.985 2.148 2.198a48.005 48.005 0 0 1-33.435 43.555A48.004 48.004 0 0 1 20.778 87.67a48 48 0 0 1 53.233-73.58c1.161.355 1.757 1.617 1.35 2.761-.407 1.144-1.663 1.735-2.826 1.386a43.603 43.603 0 1 0 31.013 43.96c.061-1.212 1.039-2.197 2.254-2.197Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M105.802 60C107.016 60 108.005 60.9849 107.95 62.1978C107.518 71.6151 104.321 80.7152 98.7343 88.3487C92.714 96.5747 84.2311 102.67 74.5146 105.753C64.7981 108.835 54.3525 108.744 44.6912 105.493C35.0298 102.242 26.6543 95.9997 20.778 87.6701C14.9017 79.3406 11.8298 69.3566 12.0073 59.1644C12.1847 48.9722 15.6023 39.1012 21.765 30.9813C27.9277 22.8614 36.5154 16.9142 46.2841 14.0014C55.3492 11.2983 64.9945 11.3385 74.0111 14.0904C75.1723 14.4448 75.7684 15.7073 75.3611 16.8512C74.9539 17.995 73.6978 18.5864 72.5349 18.2374C64.3997 15.7955 55.7107 15.7786 47.5405 18.2148C38.6666 20.8609 30.8655 26.2633 25.2673 33.6394C19.6692 41.0155 16.5646 49.9824 16.4034 59.241C16.2422 68.4995 19.0327 77.569 24.3708 85.1356C29.7088 92.7021 37.3171 98.3728 46.0935 101.326C54.8698 104.279 64.3586 104.362 73.185 101.562C82.0115 98.7618 89.7174 93.2245 95.1863 85.752C100.222 78.872 103.12 70.6807 103.548 62.1977C103.609 60.9851 104.587 60 105.802 60Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/loading.6d4914a2f3b8992e36035f073a6a6df5.svg"),
        {
          React: SvgLoading,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      